module.exports = __webpack_public_path__ + "media/images/lb/727-5c55369139b7a0e8596d10310105d44a.svg";